// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.replacedPartsBlock__jCe6i {
  width: 100%;
}

.replacedPartsTitle__z2CsZ {
  font-size: 11px;
  line-height: 13px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.replacedPartsTable__F9GHX {
  width: 100%;
  margin-top: 10px;
  table-layout: fixed;
}

.replacedPartsTableHead__pKZ9b {
  background: var(--tables-title-surface);
}

.replacedPartsTableTh__q1yHT {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  text-align: left;
  padding: 15px 0;
  background: var(--tables-title-surface);
  border-bottom: 1px solid var(--tables-title-stroke);
}
.replacedPartsTableTh__q1yHT:first-child {
  padding-left: 25px;
}
.replacedPartsTableTh__q1yHT:last-child {
  padding-right: 25px;
}

.replacedPartsTableBodyRow__X7EtH {
  background: var(--tables-secondary-row-sub-title-surface);
}

.replacedPartsTableTd__c9iIQ {
  font-size: 14px;
  line-height: 17px;
  color: var(--inputs-filled-text);
  padding: 10px 15px 10px 0;
  background: var(--tables-secondary-row-sub-title-surface);
  border-bottom: 1px solid var(--tables-title-stroke);
}
.replacedPartsTableTd__c9iIQ:first-child {
  padding-left: 25px;
}
.replacedPartsTableTd__c9iIQ:last-child {
  padding-right: 25px;
}

.tableField__PeuJH {
  height: 35px;
  padding: 11px 15px;
  display: flex;
  align-items: center;
  border-radius: 2px;
  border: 1px solid var(--inputs-filled-stroke);
  background: var(--inputs-search-surface-default);
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/ReplacedPartsComponent/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,uCAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;EACA,mDAAA;AAzEF;AA2EE;EACE,kBAAA;AAzEJ;AA4EE;EACE,mBAAA;AA1EJ;;AA8EA;EACE,yDAAA;AA3EF;;AA8EA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,yBAAA;EACA,yDAAA;EACA,mDAAA;AA3EF;AA6EE;EACE,kBAAA;AA3EJ;AA8EE;EACE,mBAAA;AA5EJ;;AAgFA;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gDAAA;AA7EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.replacedPartsBlock {\n  width: 100%;\n}\n\n.replacedPartsTitle {\n  font-size: 11px;\n  line-height: 13px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.replacedPartsTable {\n  width: 100%;\n  margin-top: 10px;\n  table-layout: fixed;\n}\n\n.replacedPartsTableHead {\n  background: var(--tables-title-surface);\n}\n\n.replacedPartsTableTh {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--tables-title-text);\n  text-transform: uppercase;\n  text-align: left;\n  padding: 15px 0;\n  background: var(--tables-title-surface);\n  border-bottom: 1px solid var(--tables-title-stroke);\n\n  &:first-child {\n    padding-left: 25px;\n  }\n\n  &:last-child {\n    padding-right: 25px;\n  }\n}\n\n.replacedPartsTableBodyRow {\n  background: var(--tables-secondary-row-sub-title-surface);\n}\n\n.replacedPartsTableTd {\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--inputs-filled-text);\n  padding: 10px 15px 10px 0;\n  background: var(--tables-secondary-row-sub-title-surface);\n  border-bottom: 1px solid var(--tables-title-stroke);\n\n  &:first-child {\n    padding-left: 25px;\n  }\n\n  &:last-child {\n    padding-right: 25px;\n  }\n}\n\n.tableField {\n  height: 35px;\n  padding: 11px 15px;\n  display: flex;\n  align-items: center;\n  border-radius: 2px;\n  border: 1px solid var(--inputs-filled-stroke);\n  background: var(--inputs-search-surface-default);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"replacedPartsBlock": `replacedPartsBlock__jCe6i`,
	"replacedPartsTitle": `replacedPartsTitle__z2CsZ`,
	"replacedPartsTable": `replacedPartsTable__F9GHX`,
	"replacedPartsTableHead": `replacedPartsTableHead__pKZ9b`,
	"replacedPartsTableTh": `replacedPartsTableTh__q1yHT`,
	"replacedPartsTableBodyRow": `replacedPartsTableBodyRow__X7EtH`,
	"replacedPartsTableTd": `replacedPartsTableTd__c9iIQ`,
	"tableField": `tableField__PeuJH`
};
module.exports = ___CSS_LOADER_EXPORT___;
